import { z } from 'zod';
import { ESlotType } from '../../../1_shared/config/enums/ESlotType';
import { DurationType } from '../../../1_shared/config/interfaces/DurationType';

export const scheduleSchema = z
  .object({
    kind: z.nativeEnum(ESlotType).nullable(),
    duration: z.nativeEnum(DurationType).nullable(),
  })
  .superRefine(({ kind, duration }, ctx) => {
    if (!kind) {
      ctx.addIssue({
        code: 'custom',
        path: ['kind'],
      });
    }
    if (!duration) {
      ctx.addIssue({
        code: 'custom',
        path: ['duration'],
      });
    }
  });

export type TScheduleForm = z.infer<typeof scheduleSchema>;
